<template>
    <div class="page noScroll">
        <div class="page-content noScroll">
            <div class="uploadPicture scroll-container">
                <!-- content -->
                <div class="nickName-container scroll-container">
                    <input type="text" placeholder="请输入昵称" name="nickname" v-model="nickName">
                    <p>为保护您的隐私，请避免用手机号等敏感信息当昵称</p>
                    <div class="js-saveName">
                        <button @click="save">保 存</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import api from '@/api'
    export default {
        name: 'NickName',
        components: {},
        data () {
            return {
                userToken: '',
                nickName: '',
                picId: ''
            }
        },
        beforeMount () {
            this.$store.commit('SET_PAGE_TITLE', '秀美图')
            this.showPage()
        },
        methods: {
            async showPage () {
                this.$loading.show()
                await this.initPage()
                this.$loading.hide()
            },
            async initPage () {
                this.userToken = this.$store.state.user.userToken
                if (!this.userToken && this.userToken.length == 0) {
                    this.$router.push(`/Orchard.Rccl.Users/Login/Login?returnUrl=${encodeURIComponent(window.location.pathname)}`)
                    return
                }
                this.nickName = this.$route.params.nickName
                this.picId = this.$route.query.picId

                this.nickName = this.nickName ? this.nickName : await this.getNickName(this.userToken)
            },
            async getNickName (userToken) {
                const {success, data, errMsg} = await api.review.getNickName(userToken)
                if (!success) {
                    console.log(errMsg)
                } else {
                    return data
                }
            },
            async save () {
                const {success, data, errMsg} = await api.review.updateNickName(this.userToken, this.nickName)
                if (!success) {
                    console.log(errMsg)
                } else {
                    console.log(data)
                    if (this.picId === undefined) {
                        this.$router.push('/Rccl.Review/ReviewPicture/UploadPicture')
                    } else {
                        this.$router.push(`/Rccl.Review/ReviewPicture/UploadPicture?picId=${this.picId}`)
                    }
                }
            }
        }
    }
</script>

<style scoped>
    .page{
        display: block;
        padding-top: 50px;
    }
    .nickName-container input{
        width:100%;
        text-align:center;
        height:46px;
        color:#666;
        font-size:13px;
        margin-top:7px;
        border:none;
        border-top:1px solid #d5d5d5;
    }
    .nickName-container input::-webkit-input-placeholder,
    .nickName-container input::-moz-placeholder,
    .nickName-container input:-moz-placeholder,
    .nickName-container input:-ms-input-placeholder {
        color:#c9c9c9;
    }
    .nickName-container p{
        margin:10px 0 0 12px;
        color:#666;
        font-size:12px;
    }
    .nickName-container div{
        width:100%;
        padding:0 12px;
        margin-top:46px;
    }
    .nickName-container button{
        width:100%;
        text-align:center;
        height:36px;
        line-height:36px;
        background-color:#f7b611;
        color:#fff;
        font-size:12.5px;
        border:none;
    }
</style>
